import SpotlightPlaceholder from './SpotlightPlaceholder'

export default SpotlightPlaceholder
// eslint-disable-next-line import/export
export * from './SpotlightPlaceholder'
